

import { Component, Prop, Vue, Watch } from "vue-property-decorator"
import { Getter, Mutation, State, Action } from "vuex-class"

import api from "@/services/api"

// @ts-ignore
import { BModal } from "bootstrap-vue"
import { TenantFeatures } from "@/types/tenantFeatures"
import { InsightDetails } from "@/types/insights"

@Component({
	components: {
	}
})
export default class InsightDeleteModal extends Vue {
	@Prop() insightToDelete!: InsightDetails | null

	@Getter getIsFeatureEnabled!: (feature: TenantFeatures) => boolean

	TenantFeatures = TenantFeatures

	deleteConfirmText: string | null = null;
	insightUsage: any = null;

	get insightInUse (): boolean {
		return this.getIsFeatureEnabled(TenantFeatures.InsightInUse) && this.insightUsage &&
			(this.insightUsage.dashboards.length > 0 || this.insightUsage.insights.length > 0)
	}

	get canDeleteInsight (): boolean {
		if (this.getIsFeatureEnabled(TenantFeatures.PreventInUseDeletion)) {
			return !this.insightInUse && !!this.insightToDelete
		} else {
			return !!this.insightToDelete
		}
	}

	get isOpen (): boolean {
		return !!this.insightToDelete
	}

	set isOpen (opened: boolean) {
		if (!opened) {
			this.close()
		}
	}

	@Watch("isOpen")
	async opened (opened: boolean) {
		if (opened) {
			this.insightUsage = await api.insightUsage(this.insightToDelete!.id!)
		}
	}

	public deleteInsight () {
		if (this.insightToDelete) {
			this.$emit("deleteConfirmed")

			this.deleteConfirmText = null
		}
	}

	public close () {
		this.deleteConfirmText = null

		this.$emit("close")
	}
}
